import { batch } from 'react-redux';

const WITH_BATCH_DISPATCH = 'WITH_BATCH_DISPATCH';
function withCtxBatchDispatch() {
  return ctx => {
    // only assign handlers if they have not been already assigned
    if (!ctx.__middleware.WITH_BATCH_DISPATCH) {
      Object.assign(ctx, {
        batchDispatch: {
          __actions: [],
          clearActions: () => {
            ctx.batchDispatch.__actions = [];
          },
          createActions: actions => {
            ctx.batchDispatch.__actions = ctx.batchDispatch.__actions.concat(actions);
          },
          dispatchActions: async () => {
            // process the action creators "creators"
            const actionCreators = await ctx.batchDispatch.__actions.reduce(async (_acc, deferredAction) => {
              const acc = await _acc;
              if (typeof deferredAction === 'function') {
                const action = await deferredAction(ctx);
                return acc.concat(action);
              }
              return acc;
            }, Promise.resolve([]));

            // batch dispatch all aggregate actions in the _actions
            batch(() => {
              actionCreators.forEach(actionCreator => ctx.store.dispatch(actionCreator));
            });

            // clear the _actions
            ctx.batchDispatch.clearActions();
          },
          getActions: () => ctx.batchDispatch.__actions
        }
      });
    }
    ctx.registerMiddleware(WITH_BATCH_DISPATCH);
  };
}

export { withCtxBatchDispatch };
